import { Spinner } from 'react-bootstrap';

const Loader = ({
  width='25px',
  height='25px',
  variant='light',
}) => {
  return (
    <Spinner
      animation='border'
      variant={variant}
      role='status'
      style={{
        width,
        height,
        margin: 'auto',
        display: 'block',
      }}
    ></Spinner>
  );
};

export default Loader;